/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { useAuthContext, InitContextProps } from "services/context/authentication.context";
import CustomerCardService from "services/customer-card.service";

interface CustomerCardPinContentProps {
  signingSessionId: string;
  remoteCardId: string;
  onExpired: () => void;
}

const PIN_TIME_SECONDS = 60;

export default function CustomerCardPinContent({ signingSessionId, remoteCardId, onExpired } : CustomerCardPinContentProps) {
  const { state }: InitContextProps = useAuthContext();
  const { customerId } = state;

  const [pin, setPin] = useState('');
  const [pinTime, setPinTime] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const fetchPin = async () => {
    try {
      setLoading(true);
      const res = await CustomerCardService.getCardPin(customerId!, signingSessionId, remoteCardId, state.customer!.contactId);
      setPin(res);
      setPinTime(PIN_TIME_SECONDS);
    } catch(e) {
      console.error(e);
      setError(true);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    if (!customerId) return;

    fetchPin();
  }, [customerId, signingSessionId, remoteCardId]);

  useEffect(() => {
    if (!pin) return;

    const timer = setInterval(() => {
      setPinTime(time => {
        if (time <= 1) {
          clearInterval(timer);
          setPin('');
          onExpired();
          return 0;
        }
        return time - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [pin]);

  if (error) {
    return <div className="text-danger text-center">Ilmnes viga PIN koodi pärimisel</div>;
  }

  if (loading) {
    return (
        <div className="d-flex justify-content-center">
          <Spinner size={"sm"} animation={"border"} />
        </div>
    );
  }

  if (!pin) {
    return <div className="text-center">PIN kood on aegunud</div>;
  }

  return (
    <div className="d-flex justify-content-center">
      <div className="d-flex flex-column align-items-center">
        <p>Teie PIN kood on</p>
        <div className="text-dark font-weight-bold u-fs-40">{pin}</div>
        <div className="text-dark font-weight-bold u-fs-20">{pinTime}</div>
      </div>
    </div>
  );
}
